"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Inner = exports.Field = exports.DurationPicker = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DurationPicker = exports.DurationPicker = _styledComponents["default"].div.withConfig({
  displayName: "styles__DurationPicker",
  componentId: "sc-crjwim-0"
})(["display:flex;text-align:center;"]);
var Inner = exports.Inner = _styledComponents["default"].div.withConfig({
  displayName: "styles__Inner",
  componentId: "sc-crjwim-1"
})(["display:flex;margin:auto;"]);
var Field = exports.Field = _styledComponents["default"].div.withConfig({
  displayName: "styles__Field",
  componentId: "sc-crjwim-2"
})(["min-width:5rem;+ ", "{margin-left:", "rem;}"], function () {
  return Field;
}, function (p) {
  return p.device === 'desktop' ? 1 : 0.5;
});
var Label = exports.Label = _styledComponents["default"].label.withConfig({
  displayName: "styles__Label",
  componentId: "sc-crjwim-3"
})(["display:block;font-size:14px;margin-top:8px;opacity:0.7;"]);
//# sourceMappingURL=styles.js.map